module.exports = __webpack_public_path__ + "static/media/house.eb3a51f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/SimpleHabitation/house.svg
// module id = 1086
// module chunks = 0